module.exports = __webpack_public_path__ + "img/home.8fd159f8.svg";